import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ModalController } from 'ionic-angular';
import { CrudProvider } from '../../providers/crud/crud';
import { UtiltiyProvider } from '../../providers/utiltiy/utiltiy';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { CabsandJobcardPage } from '../cabsand-jobcard/cabsand-jobcard';
import { SearchPage } from '../search/search';
import { CabsandTimesheetCreateAddPage } from '../cabsand-timesheet-create-add/cabsand-timesheet-create-add';
import { SelectImagePopupPage } from '../select-image-popup/select-image-popup';

@IonicPage()
@Component({
  selector: 'page-cabsand-prestart-jobcard',
  templateUrl: 'cabsand-prestart-jobcard.html',
})
export class CabsandPrestartJobcardPage {
  selectOptions: any;
  params: any;
  fleetId:any;
  payload:any;
  isUpdate: boolean = false;
  jobCardForm: FormGroup;

  requestedList: any = [];
  priorityList: any = [];
  statusList: any = [];
  completedList: any = [];
  jobTypeList: any = [];
  fleetList:any = [];
  vehicleType:any;
  commentList:any = [];
  jobNumberList:any = [];
  selectedRequest: any = "Select";
  selectedPriority: any = "";
  selectedStatus: any = "Select";
  selectedCompletd: any = "Select";
  selectedJobtype: any = "";
  selectedJob:any = "";
  selectedFleet:any = "Select";

  status:any = "";
  constructor(public navCtrl: NavController, public navParams: NavParams, private api: CrudProvider, public utiltiy: UtiltiyProvider, private formBuilder: FormBuilder, private modalController: ModalController) {
    this.selectOptions = {
      mode: 'ios'
    };
    this.params = this.navParams.get('param');
    this.fleetId = this.navParams.get('fleet');
    this.payload = this.navParams.get('payload');
    if (this.params) {
      this.isUpdate = true;
    }
    console.log("this.payload",this.payload);
   
    this.geenerateComments();
    let currentDate = new Date()
     var d = new Date();
  let aeest = d.toLocaleString( "en-US", { timeZone: "Australia/Sydney"});
  let year = d.toLocaleString( "default", { year: "numeric" ,timeZone: "Australia/Sydney"});
  let month = d.toLocaleString( "default", { month: "2-digit" ,timeZone: "Australia/Sydney"});
  let day = d.toLocaleString( "default", { day: "2-digit" ,timeZone: "Australia/Sydney"});
  var date = year + "-" + month + "-" + day;
    this.jobCardForm = this.formBuilder.group({
      // user_id: new FormControl('', [Validators.required]),
      // comment: new FormControl(''),
      // job_no: new FormControl('', [Validators.required]),
      // plant_item: new FormControl('', [Validators.required]),
      // in_date: new FormControl(date, [Validators.required]),
      // job_description: new FormControl('', [Validators.required]),
      // requested_by: new FormControl(''),
      // priority: new FormControl(''),
      // notes: new FormControl(''),
      // job_status: new FormControl('', [Validators.required]),
      // completed_by: new FormControl('', [Validators.required]),
      // // out_date: new FormControl('', [Validators.required]),
      // job_type: new FormControl(''),
      // service_hrs: new FormControl(''),
      // machine_hrs: new FormControl(''),
      // service_status: new FormControl(''),
      
      // service_kms: new FormControl(''),
      // vehicle_kms: new FormControl(''),
      // prestart_id: new FormControl('', [Validators.required]),

      user_id: new FormControl('', [Validators.required]),
      comment: new FormControl(''),
      job_no: new FormControl('', [Validators.required]),
      plant_item: new FormControl(''),
      in_date: new FormControl(date, [Validators.required]),
      job_description: new FormControl(''),
      requested_by: new FormControl(''),
      priority: new FormControl(''),
      notes: new FormControl(''),
      job_status: new FormControl(''),
      completed_by: new FormControl(''),
      out_date: new FormControl(''),
      // out_date: new FormControl('', [Validators.required]),
      job_type: new FormControl(''),
      service_hrs: new FormControl(''),
      machine_hrs: new FormControl(''),
      service_status: new FormControl(''),
      
      service_kms: new FormControl(''),
      vehicle_kms: new FormControl(''),
      prestart_id: new FormControl(''),

    });
    this.regenerateForm();




  }
  ionViewDidLoad() {
    console.log('ionViewDidLoad KlmrJobcardAddPage');
    this.getMetaData();
  }

  async getMetaData() {
    let userId = await this.utiltiy.getStorage("userId");
    if (userId) {
      this.jobCardForm.get(`user_id`).setValue(userId);
      this.jobCardForm.get(`requested_by`).setValue(userId);
    }
    if (this.fleetId) {
      this.jobCardForm.get(`prestart_id`).setValue("0");
      this.jobCardForm.get(`plant_item`).setValue(this.fleetId);
      this.jobCardForm.get(`job_description`).setValue("Fleet Number "+this.fleetId);
    }
    this.utiltiy.startLoading();
    this.jobNumberList = await this.getJobNumberData();
    this.requestedList = await this.getData("requested_list");
    this.priorityList = await this.getData("priority_list");
    this.statusList = await this.getData("status_list");
    this.completedList = await this.getData("completed_list");
    this.jobTypeList = await this.getData("job_type_list");

    let index = this.jobTypeList.findIndex(list_ => list_.job_type.toLowerCase() == "Prestart Defect".toLowerCase());
    if (index != -1) {
      this.selectedJobtype = this.jobTypeList[index].job_type;
      this.jobCardForm.get(`job_type`).setValue(this.jobTypeList[index].id);
      this.checkJobType(this.selectedJobtype);

    }
    if(!this.isUpdate){
      if(this.statusList.length != 0){
        this.jobCardForm.get(`job_status`).setValue(this.statusList[0].ID);
        this.selectedStatus = this.statusList[0].Status;
      }
    }
    console.log(" this.isUpdate", this.isUpdate)
    // if(this.isUpdate){
      this.fleetList = await this.getData("fleet_no_list");
      this.getFleetData();
    // }
    this.utiltiy.stopLoading();

    // this.locationList = await this.getLocationList();
    if (this.params) {
      this.getComment(this.params.id);
    }
  }
  

  regenerateForm() {
    this.jobCardForm.get(`notes`).setValue(this.payload.notes);
    this.jobCardForm.get(`job_description`).setValue(this.payload.jobDescription);
    this.jobCardForm.get(`plant_item`).setValue(this.payload.fleet_no);
    this.jobCardForm.get(`prestart_id`).setValue(this.payload.id);
    this.jobCardForm.get(`machine_hrs`).setValue(this.payload.hours);
    // this.jobCardForm.get(`machine_hrs`).setValue(this.payload.hours);
    
  }

  getFleetData(){
    let index = this.fleetList.findIndex(list_ => list_.fleet_no.toLowerCase() == this.payload.fleet_name.toLowerCase());
    if (index == -1) {
      return;
    }else{
      this.vehicleType = this.fleetList[index].vehicle_category;
      if(this.vehicleType == "2" || this.vehicleType ==  "3"){
        this.jobCardForm.get(`vehicle_kms`).setValue(this.fleetList[index].current_kms);
      }else{
        this.jobCardForm.get(`machine_hrs`).setValue(this.fleetList[index].current_hrs);
      }
      console.log("this.fleetList",this.fleetList[index])
    }
  }


  geenerateComments(){
    this.payload.fleetList.forEach(element => {
      if(element.status == "Faulty"){
        element.user = this.payload.drivername;
        element.isCheck = false;
        element.completed_name = [];
        element.completed_by = "";
        if(element.photo.length != 0 ){
          element.img = this.payload.file_uploaded_path+""+ element.photo ;
        }else{
          element.img = null;
        }
        this.commentList.push(element);
      }
    });
    console.log("this.commentList",this.commentList)
  }

  async addTimeSheet() {
    if (!this.jobCardForm.get('job_no').valid || !this.jobCardForm.get('job_description').valid) {
      return;
    }
    this.Prestartsubmit();
    let note = null;
    console.log(" this.jobCardForm.value", this.jobCardForm.value)
    this.commentList.forEach(element => {
      if(element.isCheck){
        note = note == null?element.name+"-"+element.comments:note+","+element.name+"-"+element.comments;
      }
    });
    // this.navCtrl.setRoot(KlmrJobcardPage);

    const modal = await this.modalController.create(CabsandTimesheetCreateAddPage, { param: null, copy: false, jobData: { job_no: this.jobCardForm.value.job_no, job_description: this.jobCardForm.value.job_description,notes:note } });
    await modal.present();
  }

  async createDataCommon(list, key, value) {
    list.forEach(element => {
      element.key = element[key];
      element.value = element[value];
    });

    return list;
  }

  async openModal(list, title, key, value, model, formkey) {
    list = await this.createDataCommon(list, key, value);
    console.log("list", list)
    const profileModal = this.modalController.create(SearchPage, { data: { list: list, header: title } }, { cssClass: 'managers', enableBackdropDismiss: true });
    profileModal.onDidDismiss(data => {
      console.log(data);
      if (data) {

        this.jobCardForm.get(formkey).setValue(data.key);
        this[model] = data.value;
        if (formkey == "job_type") {
          this.checkJobType(this[model]);
        } else if (formkey == "plant_item") {
          // this.getFleetData(data.key, "id");
        }
        // this.jobNumber = data.job_no;
        // this.dropDownChange(data.job_no,'job_no');
      }
    });
    profileModal.present();

  }

  async checkJobType(id) {
    let i = this.jobTypeList.findIndex(list_ => list_.job_type == id);
    if (i != -1) {
      if (this.jobTypeList[i].service_status == "True") {
        this.status = "At Service";
      } else {
        this.status = "";

      }
    } else {
      this.status = "";

    }

  }

  Prestartsubmit() {
    let formKeys = Object.keys(this.jobCardForm.value);
    let formData: FormData = new FormData();
    if (this.isUpdate) {
      formData.append("method_name", "jobcard_update");
      // formData.append("status", "Active");
      formData.append("jobcard_id", this.params.id);
      formKeys.forEach(key => {
        if (key != "commentValidation") {
          formData.append(key, this.jobCardForm.value[key]);
        }
      });
      this.TimeSHeetjobCard(formData,"update",true);
    } else {
      formData.append("method_name", "jobcard_store_data");
      // formData.append("status", "Active");
      formKeys.forEach(key => {
        if (key != "commentValidation") {
          formData.append(key, this.jobCardForm.value[key]);
        }
      });
      this.TimeSHeetjobCard(formData,"create",true);
    }
  }

  TimeSHeetjobCard(formData,type,status) {
    // this.utiltiy.startLoading();
    this.api.post(`/tansix_prestart/jobcard`, false, formData)
      .then((result: any) => {
        console.log("result", result);
        // this.utiltiy.stopLoading();
        if (result.status) {
          if (this.jobCardForm.value.commentValidation.length > 0) {
            if(type == "create"){
              this.TiimeSheetjobPrestartItems(result.result_id,type);
            }else{
              this.TiimeSheetjobPrestartItems(this.params.id,type);
            }
          } else {
            this.utiltiy.toaster(result.message);
           
          }

        } else {
          this.utiltiy.toaster(result.message);
        }

      }, err => {
        console.log("err", err);
        this.utiltiy.stopLoading();
        this.utiltiy.toaster(err.error.message);
      });
  }

  TiimeSheetjobPrestartItems(id,type) {
    let formData: FormData = new FormData();

    this.commentList.forEach((element,i) => {
      formData.append("item[]", element.name);
      formData.append("comment[]", element.comments);
      formData.append("completed_by[]", element.completed_by);
      console.log("element.file",element.photo)
      if(type != "create"){
        formData.append("id[]", null);
        if (element.photo != "") {
          let valueIs = element.photo
          formData.append("photo[]", element.photo);
          formData.append("photo_change[]", valueIs);
        } else {
          const file = new File([], "", {});
          formData.append("photo[]", file);
          formData.append("photo_change[]", "Y");

        }


      }else{
        formData.append("id[]","");
        if (element.file != "") {
          formData.append("photo[]", element.photo);
        } else {
          const file = new File([], "", {});
          formData.append("photo[]", file);
        }

      }
    
    });
    if(type == "create"){
      formData.append("method_name", "store_prestart_items_from_jobcard");
    }else{
      formData.append("method_name", "prestart_items_update_from_new_jobcard");
    }
    formData.append("jobcard_id", id);
    formData.append("fleet_no", this.jobCardForm.value.plant_item);
    formData.append("user_id", this.jobCardForm.value.user_id);
    // formData.append("completed_by", this.jobCardForm.value.completed_by);
    
    // this.utiltiy.startLoading();
    this.api.post(`/tansix_prestart/jobcard`, false, formData)
      .then((result: any) => {
        console.log("result", result);
        this.utiltiy.stopLoading();
        if (result.status) {
          this.utiltiy.toaster(result.message);
          // this.navCtrl.setRoot(KlmrJobcardPage);
        } else {
          this.utiltiy.toaster(result.message);
        }

      }, err => {
        console.log("err", err);
        this.utiltiy.stopLoading();
        this.utiltiy.toaster(err.error.message);
      });
  }

  

    deleteName(i,name){
    let completedName = [];
    let index = this.completedList.findIndex(list_ => list_.Person.toLowerCase() == name.toLowerCase());
    let completed_by = this.commentList[i].completed_by;

    this.commentList[i].completed_name.forEach(element => {
        if(name != element){
          completedName.push(element);
        }
    });
    
    if(index != -1){
      let j = completed_by.indexOf(this.completedList[index].id);
      let finalCompletedBy = "";
        if(j == 0){
          finalCompletedBy  = completed_by.replace(this.completedList[index].id, "")
        }else{
          finalCompletedBy  = completed_by.replace(","+this.completedList[index].id, "")
        }
        this.commentList[i].completed_name = completedName;
        this.commentList[i].completed_by =finalCompletedBy;
  }
  }
  async openModalCompleted(i,names) {
    let finalList = [];
    this.completedList.forEach(element => {
      let index = names.findIndex(list_ => list_.toLowerCase() == element.Person.toLowerCase());
      if(index == -1){
        finalList.push(element);
      }
    });
 
    let list = await this.createData(finalList, 'id', 'Person');
    console.log("list", list)
    const profileModal = this.modalController.create(SearchPage, { data: { list: list, header: "Completed By" } }, { cssClass: 'managers', enableBackdropDismiss: true });
    profileModal.onDidDismiss(data => {
      console.log(data);
      if (data) {
        let byiD = this.commentList[i].completed_by;
        this.commentList[i].completed_name.push(data.value)
        this.commentList[i].completed_by = byiD.length == 0 ?data.id:byiD+","+data.id;
      }
    });
    profileModal.present();

  }

  async createData(list, key, value) {
    list.forEach(element => {
      element.key = element[key];
      element.value = element[value];
    });

    return list;
  }




  async getComment(id) {
    let formData: FormData = new FormData();
    formData.append("method_name", "comments");
    formData.append("id", id);
    return this.api.post(`/tansix_prestart/jobcard`, false, formData)
    .then((result: any) => {
      console.log("result", result)
      
      if (result.status) {
        this.commentList = result.result
        }
      }, err => {
        console.log("err", err)
        // this.utiltiy.stopLoading();
        this.utiltiy.toaster(err.error.message);
      })
  }

  async getJobNumberData() {
    return this.api.get(`/tansix_prestart/Job_code`, false)
      .then((result: any) => {
        console.log("result", result);
        if (result.status) {
          return result.result;
        }else{
          return [];
        }
        // return true;
      }, err => {
        console.log("err", err);
        // this.utiltiy.stopLoading();
        this.utiltiy.toaster(err.error.message);
      });
  }

  async getData(methodName) {
    let formData: FormData = new FormData();
    formData.append("method_name", methodName);
    return this.api.post(`/tansix_prestart/jobcard`, false, formData)
      .then((result: any) => {
        console.log("result", result)
        if (methodName == "requested_list") {
          result.result.forEach(element => {
            element.name = element.firstName + " " + element.surname;
          });
        }
        if (result.status) {
          return result.result
        }
        return true;
      }, err => {
        console.log("err", err)
        // this.utiltiy.stopLoading();
        this.utiltiy.toaster(err.error.message);
      })
  }

  jobChanged(id) {
    this.utiltiy.startLoading();
    let formData: FormData = new FormData();
    formData.append("method_name", "job_no");
    formData.append("job_no", id);
    this.api.post(`/tansix_prestart/jobcard`, false, formData)
      .then((result: any) => {
        console.log("result", result)
        if (result.status) {
        this.jobCardForm.get(`job_no`).setValue(result.result);
        }else{
          this.utiltiy.toaster(result.message);
        }
        this.utiltiy.stopLoading();

      }, err => {
        console.log("err", err)
        this.utiltiy.stopLoading();
        this.utiltiy.toaster(err.error.message);
      })
  }

  dropDownChange(value, key) {
    this.jobCardForm.get(`${key}`).setValue(value);
  }

  submit() {
    if(this.selectedStatus != 'Closed'){
      this.jobCardForm.get(`out_date`).setValue("");
    }
    let formKeys = Object.keys(this.jobCardForm.value);
    let formData: FormData = new FormData();
    if (this.isUpdate) {
      formData.append("method_name", "jobcard_update");
      // formData.append("status", "Active");
      formData.append("id", this.params.id);
      formKeys.forEach(key => {
        formData.append(key, this.jobCardForm.value[key]);
      });
      this.jobCard(formData);
    } else {
      formData.append("method_name", "jobcard_store_data");
      // formData.append("status", "Active");
      formKeys.forEach(key => {
        formData.append(key, this.jobCardForm.value[key]);
      });
      this.jobCard(formData);
    }
  }

  
  jobCard(formData){
    this.utiltiy.startLoading();
    this.api.post(`/tansix_prestart/jobcard`, false, formData)
      .then((result: any) => {
        console.log("result", result)
        this.utiltiy.stopLoading();
        if (result.status) {
          this.jobPrestartItems(result.result_id);
          // this.utiltiy.toaster(result.message);
          // this.navCtrl.setRoot(KlmrJobcardPage);
        }else{
          this.utiltiy.toaster(result.message);
        }

      }, err => {
        console.log("err", err)
        this.utiltiy.stopLoading();
        this.utiltiy.toaster(err.error.message);
      })
  }


  jobPrestartItems(id) {

    let formData: FormData = new FormData();

    this.commentList.forEach((element,i) => {
      formData.append("item[]", element.name);
      formData.append("comment[]", element.comments);
      formData.append("completed_by[]", element.completed_by);
      console.log("element.file",element.photo)
     
        formData.append("id[]","");
        if (element.photo != "") {
          formData.append("photo[]", element.photo);
        } else {
          const file = new File([], "", {});
          formData.append("photo[]", file);
        }

    
    });
      formData.append("method_name", "store_prestart_items_from_jobcard");
    
    formData.append("jobcard_id", id);
    formData.append("fleet_no", this.jobCardForm.value.plant_item);
    formData.append("user_id", this.jobCardForm.value.user_id);
    // formData.append("completed_by", this.jobCardForm.value.completed_by);
    
    // this.utiltiy.startLoading();
    this.api.post(`/tansix_prestart/jobcard`, false, formData)
      .then((result: any) => {
        console.log("result", result);
        this.utiltiy.stopLoading();
        if (result.status) {
          this.utiltiy.toaster(result.message);
          this.navCtrl.setRoot(CabsandJobcardPage);
        } else {
          this.utiltiy.toaster(result.message);
        }

      }, err => {
        console.log("err", err);
        this.utiltiy.stopLoading();
        this.utiltiy.toaster(err.error.message);
      });
  }

  async openImage(img) {
    const modal = await this.modalController.create(SelectImagePopupPage, { param: img });
    await modal.present();
  }
}


// WEBPACK FOOTER //
// ./src/pages/cabsand-prestart-jobcard/cabsand-prestart-jobcard.ts